import instance from './common';

export function getAllProductDimenisonList(reqBody, options = {}, http = instance) {
  return http.post('/usage/all-product-dimension', reqBody, options);
}

export function getUsageMetricsData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/ei', reqBody, options);
}

export function getApiUsageMetricsData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/api', reqBody, options);
}

export function getAppUsageMetricsData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/app', reqBody, options);
}

export function getCustomerList(options = {}, http = instance) {
  return http.get('/usage/customer-list', options);
}
